export default __webpack_public_path__ + "static/media/learningContentBenifits.0a71ffab.png";